import applyInjection from './apply-injection';
import applyHook from './apply-hook';
import composeExtensionAssetUrl from './compose-extension-asset-url';
import fetchExtensionAsset from './fetch-extension-asset';
import getTranslationFunction from './get-translation-function';
import getExtensionControlsForElement from './get-extension-controls-for-element';

export default {
  applyInjection,
  applyHook,
  composeExtensionAssetUrl,
  fetchExtensionAsset,
  getTranslationFunction,
  getExtensionControlsForElement,
};
